// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Document from '@tiptap/extension-document';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import Underline from '@tiptap/extension-underline';
import { memo } from 'react'
import * as Popover from '@radix-ui/react-popover'
import { marked } from "marked";
import { toast } from 'sonner';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
// import { fetchDocument } from '../../features/document/documentSlice';
import { useParams } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { Toolbar } from '../ui/Toolbar';
import Placeholder from '@tiptap/extension-placeholder';
import { useEditorContext } from '../../context/EditorContext';
import { getToken } from '../../utils/localStorage';
import axios from 'axios';
import { fetchDocument, updateDocument } from '../../features/job/jobSlices';
import { _baseRequest, COMMON } from '../../utils/baseApi';


interface TipTapEditorProps {
  provider?: any;
  isAsideOpen?: boolean;
  onEditorReady?: (editor: any) => void;
  data?: any;
  saveRecuirements?: any;
  recuirementLoading?: boolean;
}

const JobTiptapEditor = ({
  isAsideOpen,
  onEditorReady,
  data,
  saveRecuirements,
  recuirementLoading
}: TipTapEditorProps) => {
  let [aiResponse, setAiResponse] = useState("");
  const [isModalOpenCheckbox, setIsModalOpenCheckbox] = useState(false);
  const [isModalOpenVariable, setIsModalOpenVariable] = useState(true);
  const [loadingAiResponse, setLoadingAiResponse] = useState(false)
  const [displayName, setDisplayName] = useState('Input text');
  const [isTopZero, setIsTopZero] = useState(false);
  const [modalPosition, setModalPosition] = useState(-39);
  const dispatch = useAppDispatch();
  const { baseId } = useParams<{ baseId: string }>();
  const { id } = useParams<{ id: string }>();
  const { setEditorInstance } = useEditorContext();
  const [jobTitle, setJobTitle] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const { jobId } = useParams<{ jobId: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [keyRequirements, setKeyRequirements] = useState([
    { requirement: "", id: null, isNew: true, hasChanged: false },
    { requirement: "", id: null, isNew: true, hasChanged: false }
  ]);
  const [originalRequirements, setOriginalRequirements] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [saveTimeout, setSaveTimeout] = useState(null);
  const [isAiLoading, setIsAiLoading] = useState(false);
  const [isAiResponseData, setIsAiResponseData] = useState("")

  const editor = useEditor({
    extensions: [
      Document,
      Paragraph,
      Text,
      Placeholder.configure({
        placeholder: 'Write something …',
      }),
      StarterKit
        .configure({
          document: false,
          paragraph: false,
          text: false,
          bulletList: true,
          orderedList: true,
          codeBlock: false
        }),
      Underline,
    ],
    onCreate: ({ editor }) => {
      if (setEditorInstance) {
        setEditorInstance(editor);
      }
    },
    onUpdate: ({ editor }) => {
      const content = editor.getJSON();
    },
    editorProps: {
      attributes: {
        class: 'prose prose-sm sm:prose lg:prose-lg xl:prose-2xl mx-auto focus:outline-none px-4 py-2 min-h-[540px] max-h-[590px] overflow-y-auto  rounded-md',
      },
    },
  });
  const menuContainerRef = useRef(null);
  const [promptText, setPromptText] = useState("");

  useEffect(() => {
    if (editor) {
      setEditorInstance(editor);
    }
  }, [editor, setEditorInstance]);


  const formatAiResponse = (response: string) => {
    return (
      <div
        className="prose prose-sm max-w-none"
        dangerouslySetInnerHTML={{
          __html: marked(response, {
            gfm: true,
            breaks: true,
            sanitize: false,
            smartLists: true,
            smartypants: true
          })
        }}
      />
    );
  };


  const setAiData = async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (promptText === "") {
      toast.error("Please enter prompt");
      return;
    }

    setDisplayName(promptText || "Input text");
    setLoadingAiResponse(true);

    let accumulatedData = "";
    let buffer = ""; // Buffer to store partial data

    try {
      const url = `https://atsapi.teamer.app/v1/open-api/${baseId}/tiptap.content`;
      await axios({
        method: "POST",
        url: url,
        data: {
          content: promptText,
        },
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "application/json",
          Accept: "text/event-stream",
        },
        responseType: "text", // Keep response as text
        onDownloadProgress: (progressEvent) => {
          const responseText = progressEvent.event.currentTarget?.response;
          const lines = (buffer + responseText).split("\n"); // Combine buffer and new data
          buffer = ""; // Clear buffer for new data

          lines.forEach((line, index) => {
            if (line.startsWith("data: ")) {
              try {
                const jsonData = JSON.parse(line.slice(6)); // Parse JSON after "data: "


                accumulatedData += jsonData?.content;
                setAiResponse(accumulatedData); // Update response state
              } catch (error) {
                console.error("Error parsing SSE data:", error, line);
              }
            } else if (index === lines.length - 1) {
              // Last line might be incomplete; save it to the buffer
              buffer = line;
            }
          });
        },
        withCredentials: true,
      });
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Error generating content");
    } finally {
      setLoadingAiResponse(false);
      setIsModalOpenVariable(false);
    }
  };


  const hanldeChatGpt = () => {
    setIsModalOpenCheckbox(!isModalOpenCheckbox);
    setIsTopZero(false)

    if (!isModalOpenCheckbox && aiResponse.length > 0) {
      setModalPosition(-39);
    }
  }

  const handleAiInsert = () => {
    let content = marked(aiResponse);
    editor?.chain().focus().insertContent(content).run();
    setAiResponse("");
    setIsModalOpenCheckbox(false)
    setIsTopZero(true);
    setIsModalOpenVariable(true);
    setPromptText('')
    setDisplayName('Text Input')
    setModalPosition(-39);
  };

  const handleAiCancel = () => {
    setAiResponse("");
    setIsModalOpenCheckbox(true)
    setIsTopZero(false)
    setIsModalOpenVariable(true);
    setPromptText('')
    setDisplayName('Text Input')
    setModalPosition(-39);
  };

  useEffect(() => {
    // Populate state from data
    if (data?.data) {
      setJobTitle(data.data.job_title || "");
      setJobDescription(data.data.job_description || "");
    }
  }, [data]);

  useEffect(() => {
    if (editor && data?.data?.job_description) {
      try {
        const parsedContent = JSON.parse(data.data.job_description);
        editor.commands.setContent(parsedContent);
      } catch (error) {
        console.error('Error parsing document content:', error);
      }
    }
  }, [editor, data]);




  const handleSave = async () => {
    const editorContent = editor?.getJSON();
    const editorHtml = editor?.getHTML();

    const payload = {
      id: jobId,
      baseId,
      job_title: jobTitle,
      job_description: JSON.stringify(editorContent),
      job_description_html: editorHtml,
    };

    setIsLoading(true); // Set loading state to true when starting
    try {
      await dispatch(updateDocument(payload)).unwrap();
      toast.success('Job detail updated successfully');
      await dispatch(fetchDocument({ baseId, id: jobId }));
    } catch (error) {
      toast.error('Failed to update document');
      console.error('Update Document Error:', error);
    } finally {
      setIsLoading(false); // Reset loading state when done
    }
  };

  useEffect(() => {
    if (saveRecuirements?.data && Array.isArray(saveRecuirements.data)) {
      const requirements = saveRecuirements.data.map((item: any) => ({
        requirement: item.requirement || "",
        id: item.id || null,
        isNew: false,
        hasChanged: false,
        originalValue: item.requirement || ""
      }));
      setOriginalRequirements([...requirements]);

      if (requirements.length === 0) {
        const emptyReqs = [
          { requirement: "", id: null, isNew: true, hasChanged: false },
          { requirement: "", id: null, isNew: true, hasChanged: false }
        ];
        setKeyRequirements(emptyReqs);
        setOriginalRequirements([]);
      } else {
        const minRequirements = [...requirements];
        while (minRequirements.length < 2) {
          minRequirements.push({ requirement: "", id: null, isNew: true, hasChanged: false });
        }
        setKeyRequirements(minRequirements);
      }
    }
  }, [saveRecuirements]);


  const addRequirementInput = () => {
    if (keyRequirements.length < 20) {
      setKeyRequirements([
        ...keyRequirements,
        { requirement: "", id: null, isNew: true, hasChanged: false }
      ]);
    }
  };

  const removeRequirementInput = async (index: number) => {
    if (keyRequirements.length > 2) {
      const reqToRemove = keyRequirements[index];
      if (reqToRemove.id) {
        try {
          const deleteUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${reqToRemove?.id}/jobRequirement.Delete`;
          await _baseRequest(deleteUrl, 'DELETE');
          toast.success('Requirement deleted successfully');
        } catch (error) {
          toast.error('Failed to delete requirement');
          return;
        }
      }

      const updatedRequirements = keyRequirements.filter((_, i) => i !== index);
      setKeyRequirements(updatedRequirements);
    }
  };

  const handleKeyRequirementChange = (index: number, value: string) => {
    const updatedRequirements = [...keyRequirements];
    const req = updatedRequirements[index];

    req.requirement = value;
    if (req.isNew) {
      req.hasChanged = value.trim() !== '';
    } else {
      req.hasChanged = value !== req.originalValue;
    }

    setKeyRequirements(updatedRequirements);
  };

  const saveKeyRequirements = async () => {
    const requirementsToSave = keyRequirements.filter(req =>
      req.hasChanged && req.requirement.trim() !== ''
    );

    if (requirementsToSave.length === 0) {
      return;
    }

    setIsSaving(true);
    try {
      for (const reqObj of requirementsToSave) {
        let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/jobRequirement.addParent`;
        if (reqObj.id) {
          fullUrl += `?parent_id=${reqObj.id}`;
        }

        const payload = {
          base_id: Number(baseId),
          job_id: jobId,
          requirement: reqObj.requirement.trim(),
        };

        const res = await _baseRequest(fullUrl, 'POST', payload);
        if (!reqObj.id && res.data?.id) {
          reqObj.id = res.data.id;
        }
        reqObj.hasChanged = false;
        reqObj.isNew = false;
        reqObj.originalValue = reqObj.requirement;
      }

      setKeyRequirements([...keyRequirements]);
      toast.success(`${requirementsToSave.length} requirement(s) saved successfully`);

    } catch (error) {
      toast.error(error?.data?.message || 'Failed to save requirements');
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleKeyRequirementChangeWithAutoSave = (index: number, value: string) => {
    handleKeyRequirementChange(index, value);
    if (saveTimeout) {
      clearTimeout(saveTimeout);
    }
    const timeout = setTimeout(() => {
      saveKeyRequirements();
    }, 1000);

    setSaveTimeout(timeout);
  };


  const handleKeyRequirementKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      saveKeyRequirements();
    }
  };


  // Add this function to handle clicking on AI-generated requirements
  const handleAiRequirementClick = async (requirement: string) => {
    try {
      // Find the first empty input field
      const emptyIndex = keyRequirements.findIndex(req => req?.requirement?.trim() === '');
      if (emptyIndex !== -1) {
        // Fill the first empty input and save to API
        const updatedRequirements = [...keyRequirements];
        updatedRequirements[emptyIndex] = {
          ...updatedRequirements[emptyIndex],
          requirement: requirement,
          hasChanged: true,
          isNew: true
        };

        setKeyRequirements(updatedRequirements);

        // Save to API immediately
        await saveSpecificRequirement(updatedRequirements[emptyIndex], emptyIndex);

      } else if (keyRequirements.length < 20) {
        // If no empty fields, add a new one with the requirement
        const newRequirement = {
          requirement: requirement,
          id: null,
          isNew: true,
          hasChanged: true
        };

        const updatedRequirements = [...keyRequirements, newRequirement];
        setKeyRequirements(updatedRequirements);

        // Save to API immediately
        await saveSpecificRequirement(newRequirement, updatedRequirements.length - 1);

      } else {
        // If all fields are full and at max capacity, show a message
        // toast.info('Maximum 5 requirements allowed. Please clear a field first.');
         toast.info('Maximum 20 requirements allowed. Please clear a field first.');
      }
    } catch (error) {
      console.error('Error adding AI requirement:', error);
      toast.error('Failed to add requirement');
    }
  };

  // New function to save a specific requirement to API
  const saveSpecificRequirement = async (reqObj: any, index: number) => {
    if (!reqObj.requirement.trim()) return;

    setIsSaving(true);
    try {
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/jobRequirement.addParent`;

      if (reqObj.id) {
        fullUrl += `?parent_id=${reqObj.id}`;
      }

      const payload = {
        base_id: Number(baseId),
        job_id: jobId,
        requirement: reqObj.requirement.trim(),
      };

      const res = await _baseRequest(fullUrl, 'POST', payload);

      // Update the requirement with the new ID from API response
      if (!reqObj.id && res.data?.id) {
        const updatedRequirements = [...keyRequirements];
        updatedRequirements[index] = {
          ...updatedRequirements[index],
          id: res.data.id,
          hasChanged: false,
          isNew: false,
          originalValue: reqObj.requirement
        };
        setKeyRequirements(updatedRequirements);
      }

      toast.success('Requirement added successfully');

    } catch (error) {
      toast.error(error?.data?.message || 'Failed to save requirement');
      console.error('Save requirement error:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const handleAiResponseAppend = async () => {
    try {
      setIsAiLoading(true);
      let fullUrl = `${COMMON.apiBaseUrl()}/v1/${baseId}/${jobId}/jobPost.aiContent`;

      const response = await _baseRequest(fullUrl, 'PUT');

      if (response.status === 200) {
        toast.success("AI response generated successfully");
        setIsAiResponseData(response?.data);


        if (editor && response?.data?.job_description) {
          try {
            if (typeof response.data.job_description === 'string') {
              // If it's HTML/text, insert it at current cursor position
              editor.chain().focus().insertContent(response.data.job_description).run();
            } else {
              // If it's JSON, you might need to convert it to HTML first
              const html = editor.generateHTML(response.data.job_description);
              editor.chain().focus().insertContent(html).run();
            }
          } catch (error) {
            console.error('Error appending AI response to editor:', error);
          }
        }
      }
    } catch (error) {
      toast.error(error, "Failed to generate AI response");
    } finally {
      setIsAiLoading(false);
    }
  };




  if (!editor) {
    return null;
  }


  return (
    <div className='flex gap-x-5 h-full justify-between'>
      <div className='w-full max-w-[100%] bg-white rounded-lg tiptap-editor-container h-full '>

        <div className="relative max-w-full md:max-w-[640px] lg:max-w-[640px] m-auto flex flex-col flex-1 h-full overflow-visible" ref={menuContainerRef}>
          <div className='flex flex-col gap-y-4'>
            <div className="sm:col-span-4">
              <label
                htmlFor="username"
                className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
              >
                Job Title
              </label>
              <div className="mt-[6px]">
                <input
                  id="job-title"
                  name="jobTitle"
                  type="text"
                  value={jobTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                  placeholder="Enter Job Title"
                  className="flex grow rounded-md border-[#e5e7eb] !text-[16px] text-[#37352f]
                  border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500
                   outline-primary focus:outline focus:outline-2 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600"
                />
              </div>
            </div>
            <div className="sm:col-span-4 relative">

              <div className='flex items-center gap-x-2 justify-between w-full'>
                <label
                  htmlFor="job-description"
                  className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                >
                  Job   Description
                </label>
                {
                  !isAiResponseData &&
                  <span
                    onClick={handleAiResponseAppend}
                    className="inline-flex cursor-pointer w-fit items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-normal text-gray-700 ring-1 ring-inset ring-gray-700/10">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="w-3 h-3 mr-[6px] text-gray-700 "
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                      />
                    </svg>
                    {isAiLoading ? (
                      <div className='flex items-center  gap-[6px]'>
                        Ai response
                        <div className="simple-spinner">
                          <span style={{ borderRightColor: '#374151' }}></span>
                        </div>
                      </div>
                    ) : (
                      'Ai response'
                    )}

                  </span>
                }
              </div>

              <div className='flex mt-[6px] grow rounded-lg border bg-background px-0 py-[0px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 
                   placeholder:text-surface-500 outline-primary focus:outline focus:outline-2 focus:-outline-offset-2 w-full text-surface-900 
                   hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 h-[650px]'>
                <EditorContent editor={editor} className="flex-1" />
              </div>
              <div className={`absolute p-2 ${isModalOpenCheckbox ? 'rounded-b-lg' : 'rounded-lg'}
              ${isAsideOpen ? 'mq1800:left-[12.2%] mq3000:left-[12.2%]' :
                  isModalOpenCheckbox ? 'mq1800:left-[13%] mq3000:left-[12.2%]' : 'mq1800:left-[12.5%] mq3000:left-[12.1%]'} 
                 bottom-[0px] mx-5 bg-white shadow-sm border border-neutral-200 flex items-center gap-x-2`}
              >
                <div open={isModalOpenCheckbox} onClose={() => { }} className={`${isModalOpenCheckbox ? 'common-slider-one' : 'common-slider-two'}`}
                >

                  <div
                    className={`fixed flex checkbox-modal h-[40px] w-[441px] max-w-[441px] bottom-0
           ${isModalOpenCheckbox ? '' : '!top-[2px]'}
           ${isTopZero ? '!top-[49px]' :
                        aiResponse.length > 0 ? 'top-[-415px] h-[240px]' :
                          !isTopZero ? 'top-[-39px]' :
                            `top-[${modalPosition}px]`}`}
                  >
                    <div
                      className={`${aiResponse.length > 0 ?
                        'flex h-auto flex-col bg-white pt-2 pb-2 rounded-t-lg border border-neutral-200' :
                        'flex h-auto flex-col bg-white pt-3 pb-3 rounded-t-lg border border-neutral-200'}`}
                    >
                      <div className="px-2 sm:px-3">
                        <label htmlFor="name"
                          className={`${aiResponse.length > 0 ? 'text-[0.875rem] block mb-6  text-dark-black-100 capitalize' : 'text-[0.875rem] block mb-2  text-dark-black-100 capitalize'}`}
                        >
                          <span className='text-[16px] font-medium'> {displayName}</span>
                          {
                            aiResponse.length > 0 &&
                            <div className='border-b border-neutral-200 mx-[-12px] py-1'></div>
                          }

                          {aiResponse && (
                            <div className="overflow-auto h-[350px]  pt-2">
                              {formatAiResponse(aiResponse)}
                            </div>
                          )}
                        </label>
                        {
                          aiResponse.length > 0 &&
                          <div className='border-b border-neutral-200 mx-[-12px]'></div>
                        }
                        <div
                          className={`${aiResponse ? 'flex items-end justify-between gap-x-3 mt-2' : 'flex items-end justify-between gap-x-3 mt-0'}`}
                        >
                          {
                            isModalOpenVariable &&
                            <>
                              <div className='flex items-start flex-col justify-start w-full'>

                                <div className="relative w-full">
                                  <input
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={promptText}
                                    onChange={(e) => setPromptText(e.target.value)}
                                    className="flex w-full grow border px-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] focus:ring-indigo-500 transition-colors duration-100 placeholder:text-surface-500
                     outline-indigo-600   focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                  border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                                  />
                                </div>
                              </div>
                              <div className="flex items-center">
                                <div className="w-full flex items-center justify-between">
                                  <div className="flex items-center gap-[0.5rem]">
                                    <button className="flex w-full justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm
                     hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                      onClick={(e) => setAiData(e)}
                                    >
                                      {loadingAiResponse ? (
                                        <div className='flex items-center  gap-[6px]'>
                                          Enter
                                          <div className="simple-spinner">
                                            <span></span>
                                          </div>
                                        </div>
                                      ) : (
                                        'Enter'
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          }
                          {
                            !isModalOpenVariable &&
                            <div className='flex justify-end gap-x-2 w-full'>

                              <button
                                className="flex w-fit justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-black shadow-sm
                         focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 ring-1 
                         ring-inset ring-gray-300"
                                onClick={handleAiCancel}

                              >
                                Cancel
                              </button>
                              <button
                                onClick={handleAiInsert}
                                className="flex w-fit justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm
                       hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                              >
                                Insert
                              </button>
                            </div>
                          }
                        </div>
                      </div>

                    </div>
                  </div>

                </div>




                <button
                  onClick={hanldeChatGpt}
                  data-title="Ai"
                  style={{ transitionProperty: 'background-color,border-color,color,fill,stroke,opacity,box-shadow,transform' }}
                  className={`${isModalOpenCheckbox ? 'bg-gray-200' : 'bg-white'} table-tooltip rounded-md duration-200 font-[600]  px-1.5 text-[0.8125rem] h-[28px] w-[28px] flex items-center justify-center border border-solid border-[#e7e7e8]`}

                >
                  <svg xmlns="http://www.w3.org/2000/svg"
                    height="1.3em" width="1.3em" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    className="icon icon-tabler icons-tabler-outline icon-tabler-sparkles"
                  ><path stroke="none" d="M0 0h24v24H0z"
                    fill="none" />
                    <path d="M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 
                     6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z" /></svg>
                </button>
                <button
                  data-title="Bold"
                  onClick={() => editor.chain().focus().toggleBold().run()}
                  className={editor.isActive('bold') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : ' table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="Bold" />
                </button>
                <button
                  data-title="Italic"
                  onClick={() => editor.chain().focus().toggleItalic().run()}
                  className={editor.isActive('Italic') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}

                >
                  <Icon name="Italic" />
                </button>
                <button
                  data-title="Underline"
                  onClick={() => editor.chain().focus().toggleUnderline().run()}
                  className={editor.isActive('Underline') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="Underline" />
                </button>
                <Toolbar.Divider />
                <button data-title="Undo"
                  onClick={() => editor.chain().focus().undo().run()}
                  className={editor.isActive('Undo') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="Undo" />
                </button>
                <button data-title="Redo"
                  onClick={() => editor.chain().focus().redo().run()}
                  className={editor.isActive('Redo') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="Redo" />
                </button>
                <Toolbar.Divider />
                <button
                  data-title="strike"
                  onClick={() => editor.chain().focus().toggleStrike().run()}
                  className={editor.isActive('strike') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="Strikethrough" />

                </button>
                <Toolbar.Divider />
                <button
                  data-title="bullet list"
                  onClick={() => editor.chain().focus().toggleBulletList().run()}
                  className={editor.isActive('bulletList') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <Icon name="List" />
                </button>
                <button
                  data-title="numbered list"
                  onClick={() => editor.chain().focus().toggleOrderedList().run()}

                  className={editor.isActive('orderedList') ? 'table-tooltip is-active flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto' : 'table-tooltip flex group items-center justify-center border text-sm font-semibold rounded-md disabled:opacity-50 whitespace-nowrap bg-transparent border-transparent text-neutral-500 dark:text-neutral-400 hover:bg-black/5 hover:text-neutral-700 active:bg-black/10 active:text-neutral-800 dark:hover:bg-white/10 dark:hover:text-neutral-300 dark:active:text-neutral-200 h-8 gap-1  px-2 w-auto'}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-list-ordered w-4 h-4"
                  >
                    <path d="M10 12h11" />
                    <path d="M10 18h11" />
                    <path d="M10 6h11" />
                    <path d="M4 10h2" />
                    <path d="M4 6h1v4" />
                    <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" />
                  </svg>

                </button>

              </div>
            </div>


            <div className='flex justify-end mt-8'>
              <button
                onClick={handleSave}
                className='group inline-flex w-auto  shrink-0 select-none transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 
                focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] rounded-md text-white outline-primary disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600
                         justify-start [&>span]:flex [&>span]:items-center [&>span]:gap-[6px] '>
                {isLoading ? (
                  <div className='flex items-center  gap-[6px]'>
                    Save
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  'Save'
                )}
              </button>
            </div>


            {/* Key Requirements Section */}
            <div className="sm:col-span-4 mt-8">
              <div className="flex items-center justify-between">
                <label
                  htmlFor="key-requirements"
                  className="text-[16px] lg:text-lg font-medium text-gray-900"
                >
                  Key Requirements
                </label>
              </div>

              <p className="text-sm text-gray-500 mt-1 mb-5">
                List the top skills, qualifications, or experiences essential for success in this role. Focus on up to five clear and concise requirements that highlight what you're looking for in an ideal candidate.
              </p>
              <div className="mt-[6px] space-y-3">
                {keyRequirements.map((reqObj, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <input
                      id={`key-requirement-${index}`}
                      name={`keyRequirement${index}`}
                      type="text"
                      value={reqObj.requirement}
                      onChange={(e) => handleKeyRequirementChange(index, e.target.value)}
                      onBlur={saveKeyRequirements}
                      onKeyPress={handleKeyRequirementKeyPress}
                      placeholder={`Add requirement`}
                      className="flex grow rounded-md border-[#e5e7eb] !text-[14px] text-[#37352f]
                      border bg-background px-2 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500
                       outline-primary focus:outline focus:outline-2 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200
                        border-surface-200 dark:border-surface-100 focus:outline-indigo-600"
                    />
                    {keyRequirements.length > 2 && (
                      <button
                        type="button"
                        onClick={() => removeRequirementInput(index)}
                        className="flex-shrink-0 p-1  transition-colors duration-150"
                        title="Remove requirement"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-x   w-[0.8rem] h-[0.8rem] text-[#808080]"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M18 6l-12 12" />
                          <path d="M6 6l12 12" />
                        </svg>
                      </button>
                    )}
                  </div>
                ))}
                {keyRequirements.length < 20 && (
                  <button
                    type="button"
                    onClick={addRequirementInput}
                    className="inline-flex items-center gap-1 px-2 py-1 text-[12px] text-indigo-600 hover:text-indigo-600 rounded transition-colors duration-150"
                  >
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                    </svg>
                    Add
                  </button>
                )}
                {
                  isAiResponseData?.job_requirements &&
                  <div className="mt-4">
                    <div className="flex items-center justify-between">
                      <label
                        htmlFor="key-requirements"
                        className="text-sm text-gray-500 mt-1 mb-3"
                      >
                        AI  Requirements
                        <span className="text-sm text-gray-500 ml-2">
                          (Click to add)
                        </span>
                      </label>
                    </div>
                    <div className="flex items-center gap-2 w-full flex-wrap">
                      {isAiResponseData?.job_requirements.map((requirement: string, index: number) => (
                        <span key={index}
                          onClick={() => handleAiRequirementClick(requirement)}
                          className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1 
                           text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">{requirement}</span>
                      ))}
                    </div>
                  </div>
                }
              </div>
            </div>


          </div>


        </div>



      </div>
    </div>
  );
};

export default JobTiptapEditor;
